import apiClient from './apiClient';

// Tenant API endpoints
export const createTenant = async (tenantData) => {
  const response = await apiClient.post('/auth/tenant/create', tenantData);
  return response.data;
};

export const getTenants = async (params = {}) => {
  const response = await apiClient.get('/admin/clients', { params });
  return response.data;
};

export const getDashboardStats = async () => {
  const response = await apiClient.get('/admin/dashboard/stats');
  return response.data;
};

export const getTenant = async (tenantId) => {
  const response = await apiClient.get(`/admin/clients/${tenantId}/details`);
  return response.data;
};

export const updateTenant = async (tenantId, updateData) => {
  const response = await apiClient.put(`/admin/clients/${tenantId}`, updateData);
  return response.data;
};

export const suspendTenant = async (tenantId, suspensionData) => {
  const response = await apiClient.put(`/admin/clients/${tenantId}/suspend`, suspensionData);
  return response.data;
};

export const reactivateTenant = async (tenantId) => {
  const response = await apiClient.put(`/admin/clients/${tenantId}/reactivate`);
  return response.data;
};

export const getTenantUsers = async (tenantId) => {
  const response = await apiClient.get(`/admin/clients/${tenantId}/users`);
  return response.data;
};

export const resetTenantUserPassword = async (tenantId, userId) => {
  const response = await apiClient.post(`/admin/clients/${tenantId}/users/${userId}/reset-password`);
  return response.data;
};

const tenantApi = {
  createTenant,
  getTenants,
  getDashboardStats,
  getTenant,
  updateTenant,
  suspendTenant,
  reactivateTenant,
  getTenantUsers,
  resetTenantUserPassword
};

export default tenantApi;